<template>
    <div>
        <v-layout wrap row justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
                <h1 class="animated bounceIn dura-1"><span class="icon-titulo"></span>Generalidades del monitoreo de atmósferas</h1>    
                <h2 v-if="onboarding!==1 && onboarding!==3 && onboarding!==4" class="animated bounceIn dura-2">Limitaciones de la prueba de gases</h2>
                <h2 v-if="onboarding===1" class="animated bounceIn dura-2">Consideraciones en el monitoreo de atmósferas asociadas a la actividad</h2>
                <h2 v-if="onboarding===3 || onboarding===4 " class="animated bounceIn dura-2">Consideraciones en el monitoreo de atmósferas asociadas a la actividad</h2>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-center">
                <div class="cont-pq">
                    <v-card color="transparent" flat tile>
                        <v-window v-model="onboarding">
                            <v-window-item v-for="n in length" :key="`card-${n}`">
                                <v-card class="cont_text-slider" color="transparent" flat>
                                    <div class="flip-item">
                                        <div class="slider-cont--img animated flipInY">
                                            <img :src="require('@/assets/unidad1/pantalla-9-'+(onboarding+2)+'.png')" alt="">
                                        </div>
                                        <v-card class="cont_text-slider-1" color="transparent" flat>
                                            <div class="flip-item-1">
                                                <p class="mt-2">{{complemento[onboarding]}}</p>
                                            </div>
                                        </v-card>
                                    </div>
                                </v-card>
                            </v-window-item>
                        </v-window>
                        <v-card-actions class="cont_buttons-slider">
                            <v-item-group light v-model="onboarding" class="text-center " mandatory>
                                <v-item v-for="n in length" :key="`btn-${n}`" v-slot:default="{ active, toggle }">
                                    <v-btn :color="vistos[n-1] ? '#FFAF50' : '#28F7D1'" small class="item-button" :input-value="active" icon @click="toggle">
                                        <v-icon>mdi-record</v-icon>
                                    </v-btn>
                                </v-item>
                            </v-item-group>
                        </v-card-actions>
                    </v-card>
                </div>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-left" v-if="mostrar">
                <p class="animated bounceIn dura-1">Finalmente, para cerrar esta primera unidad, revisemos algunos aspectos generales muy importantes relacionados con la prueba de gases.</p>
            </v-flex>
            <v-layout wrap row justify-center align-center text-xs-center pb-5 mt-2 class="cont_page textosIconos" v-if="mostrar">
                <scrolldown-app></scrolldown-app>
                <v-flex xs12 sm7 md1 class="text-xs-center">
                    <img class="animated bounceIn dura-2" src="@/assets/unidad1/pantalla-9-7.png" alt="seguridad">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-3">La prueba de gases <strong>no garantiza</strong> que un trabajo sea seguro. Es un paso <strong>necesario, pero no suficiente.</strong> Se deben analizar las condiciones del área y del equipo o sistema a intervenir, y analizar lo que puede
                        pasar al realizar la labor</p>
                    <hr class="animated bounceIn dura-3">
                </v-flex>
                <v-flex sm12 md12></v-flex>
                <v-flex xs12 sm7 md1 class="text-xs-center">
                    <img class="animated bounceIn dura-4" src="@/assets/unidad1/pantalla-9-8.png" alt="seguridad">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-5">Ten precaución al evaluar el trabajo a realizar ya que puede darse el caso de resultado de prueba negativa y al calentar o intervenir el equipo, generar gases inflamables y/o tóxicos que puedan generar un incidente.</p>
                    <hr class="animated bounceIn dura-5">
                </v-flex>
                <v-flex sm12 md12></v-flex>
    
                <v-flex xs12 sm7 md1 class="text-xs-center">
                    <img class="animated bounceIn dura-6" src="@/assets/unidad1/pantalla-9-9.png" alt="seguridad">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-7">La realización de la prueba es una actividad riesgosa. <strong>Asegúrate de tomar las medidas de seguridad como si los resultados de las pruebas fuesen positivos.</strong></p>
                    <hr class="animated bounceIn dura-7">
                </v-flex>
                <v-flex sm12 md12></v-flex>
    
                <v-flex xs12 sm7 md1 class="text-xs-center">
                    <img class="animated bounceIn dura-8" src="@/assets/unidad1/pantalla-9-10.png" alt="seguridad">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-9">No recargues ni reemplaces baterías en una atmosfera inflamable. </p>
                    <hr class="animated bounceIn dura-9">
                </v-flex>
                <v-flex sm12 md12></v-flex>
                <v-flex xs12 sm7 md1 class="text-xs-center">
                    <img class="animated bounceIn dura-10" src="@/assets/unidad1/pantalla-9-11.png" alt="seguridad">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-11">No utilices el equipo con bomba integrada durante largos periodos de tiempo en una atmosfera que contenga una concentración de gases o vapores inflamables superior al 10% del LEL (saturación de sensores).</p>
                    <hr class="animated bounceIn dura-11">
                </v-flex>
                <v-flex sm12 md12></v-flex>
    
                <v-flex xs12 sm7 md1 class="text-xs-center">
                    <img class="animated bounceIn dura-12" src="@/assets/unidad1/pantalla-9-12.png" alt="seguridad">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-13">Reconoce el área donde se va a realizar el trabajo. Mira arriba, abajo, a los lados y adelante.</p>
                    <hr class="animated bounceIn dura-13">
                </v-flex>
            </v-layout>
        </v-layout>
    </div>
</template>

<script>
export default {
    data() {
        return {
            vistos: Array(5).fill(false),
            bottomNav: "recent",
            onboarding: 0,
            length: 5,
            complemento: [
                'El monitoreo de atmósferas no se debe realizar cuando se presente precipitación (lluvia) o vapor de agua en el ambiente, ya que los resultados no serían confiables.',
                'El monitoreo de atmósferas no es confiable con concentración de oxígeno menor del 15% o en atmósferas ricas en oxígeno por encima del 23%, en estos casos el ambiente se debe considerar con riesgo de inflamabilidad y/o toxicidad.',
                'Cuando la prueba de gases se hace en ambientes de alta temperatura, mayor a 50°C. Se afecta la sensibilidad del detector de gases.',
                'Ampliar el tiempo de monitoreo si la prueba de gases marca valores diferentes a los normalmente esperados, esto indicaría que una fuente no está en control y, por tanto, que el trabajo no será seguro.',
                'En espacios confinados, la prueba de gases debe ser realizadas dentro y fuera.'
            ],
            mostrar: false,
        }
    },
    mounted() {
        this.$set(this.vistos, 0, true)
        setTimeout(() => {
            this.$store.commit('nextShow', false)
        }, 3000);
    },
    watch: {
        onboarding(val) {
            this.$set(this.vistos, val, true);
            let value = this.vistos.find(element => {
                return element == false;
            });
            console.log(value)
            if (value == undefined) {
                this.mostrar = true;
                setTimeout(() => {
                    this.$store.commit('nextShow', true)
                }, 8000);
            }
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../../sass/globals';
.cont_buttons-slider-1 {
    justify-content: center;
    .item-button {
        width: 15px;
        height: 15px;
    }
}

.flip-item-1 {
    position: relative;
    width: 100%;
    height: auto;
    padding: 10px;
    background: white;
    p {
        text-align: center;
    }
    .pb {
        color: $color-secondary;
        font-family: FontBase-Bold;
    }
    @media screen and (max-width: 330px) {
        img {
            width: 150px;
        }
    }
}

.cont-pq {
    width: 60%;
    margin: 0 auto;
    @media screen and (max-width: 330px) {
        width: 100%;
    }
}

.btn-img--wb {
    width: 120px;
}

.cont_buttons-slider {
    justify-content: center;
    .item-button {
        width: 15px;
        height: 15px;
    }
}

.flip-item {
    position: relative;
    width: 100%;
    height: auto;
    padding: 10px;
    p {
        text-align: center;
        margin: 0;
        padding: 0;
    }
    @media screen and (max-width: 330px) {
        img {
            width: 150px;
        }
    }
}

.slider-cont--img {
    margin: 0 auto;
    min-width: 200px;
    min-height: 212px;
    img {
        width: 40%;
    }
    @media screen and (max-width: 1650px) {
        min-width: 100% !important;
        min-height: 100px;
        img {
            width: 70%;
        }
    }
    @media screen and (max-width: 950px) {
        min-width: 100% !important;
        min-height: 100px;
        img {
            width: 100%;
        }
    }
}

.pantalla {
    @media screen and (max-width: 600px) {
        display: none;
    }
}

.mobile {
    @media screen and (min-width: 600px) {
        display: none;
    }
    @media screen and (max-width: 600px) {
        display: block;
    }
}

hr {
    height: 2px;
    background-color: $color-complement-one;
    border: none;
    margin-bottom: 1em;
}
.textosIconos{
    p{
    margin-left:0.5em;
    }
}
</style>